import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { Provider } from "@redotech/redo-model/order";
import { createContext, memo, ReactNode } from "react";

export const EnabledFulfillmentProvidersContext = createContext<
  readonly Provider[] | undefined
>(undefined);

export const EnabledFulfillmentProvidersProvider = memo(
  function EnabledFulfillmentProvidersProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const client = useRequiredContext(RedoMerchantRpcClientContext);

    const enabledOmsProvidersLoad = useLoad(
      (signal) => client.getEnabledProviders({}, { signal }),
      [client],
    );

    // Don't render children until providers are loaded
    if (!enabledOmsProvidersLoad.value) {
      return null;
    }

    return (
      <EnabledFulfillmentProvidersContext.Provider
        value={enabledOmsProvidersLoad.value ?? []}
      >
        {children}
      </EnabledFulfillmentProvidersContext.Provider>
    );
  },
);
